export const FIELD_LIMITS = {
  message: 1000,
  stack: 6000,
  componentStack: 3000,
  digest: 100,
  pathname: 500,
  source: 50,
  boundary: 100,
  errorName: 100,
} as const

export const clip = (value: unknown, max: number): string | undefined =>
  typeof value === 'string' && value.length > 0
    ? value.slice(0, max)
    : undefined
